<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <v-card class="auth-card">
        <v-card-text class="d-flex align-center justify-center flex-column pa-8">
          <div class="d-flex align-center justify-center mb-6">
            <v-img
              style="box-shadow: none; border-radius: 0;"
              :src="require('@/assets/images/logo.png')"
              max-width="200"
              contain
            ></v-img>
          </div>

          <div class="text-center mb-8">
            <v-icon size="80" color="warning" class="mb-4">
              {{ icons.mdiClockOutline }}
            </v-icon>

            <h2 class="text-h4 font-weight-bold mb-4">
              Waiting for approval
            </h2>

            <p class="text-body-1 mb-2">
              Your registration at Perform72 has been received
            </p>
            <p class="text-body-1 mb-6">
              and is currently pending approval.
            </p>
          </div>

          <v-btn
            color="primary"
            large
            block
            @click="onLogout"
          >
            Logout
          </v-btn>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mdiClockOutline } from '@mdi/js'
import { useRouter } from '@/utils/index'
import useAuth from '@/composables/useAuth'

export default {
  name: 'PendingApproval',

  setup() {
    const { router } = useRouter()
    const { logout } = useAuth()

    const onLogout = async () => {
      try {
        await logout()
        router.push({ name: 'login' })
      } catch (error) {
        console.error('Logout error:', error)
      }
    }

    return {
      icons: {
        mdiClockOutline,
      },
      onLogout,
    }
  },
}
</script>

<style lang="scss" scoped>
.auth-wrapper {
  display: flex;
  flex-basis: 100%;
  min-height: 100vh;
  width: 100%;

  .auth-inner {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
  }

  .auth-card {
    max-width: 500px;
    width: 100%;
  }
}
</style>
